import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"

// import Toast from 'vue-toastification'
// import 'vue-toastification/dist/index.css'

require('@/assets/css/style.css')
require('@/assets/css/brookside.css')

const app = createApp(App);

const conf = app.config.globalProperties;
//global vars
    conf.$glob = {
        // companyName: "Brookside Laser, LLC & Brookside Custom",
        // companyShortName: "Brookside Laser",
        // logoSquare: require('@/assets/images/_brookside/BrooksideLaser_Mark_v2.6_transparent.svg'),
        // logoBanner: require('@/assets/images/_brookside/BrooksideLaser_Logo_v2.6_transparent.svg'),
        logoSquare: require('@/assets/images/_brookside/BrooksideLaser_Printing_Mark_v1.0_transparent.svg'),
        logoBanner: require('@/assets/images/_brookside/BrooksideLaser_Printing_Logo_v1.0_transparent.svg'),
        enableLogin: false,
    }
    conf.$company = {
        shortName: 'Brookside Laser and Printing',
        legalName: 'Brookside Laser, LLC',
        legal: {
            address1: '2222 W Grand River Ave',
            address2: 'Ste A',
            city: 'Okemos',
            state: 'MI',
            zip: '48864',
            country: 'United States',
            venue: 'Newaygo County, Michigan',
        },
        fullName: 'Brookside Laser, LLC dba Brookside Laser and Printing',
        phone: '231.928.8820',
        phoneLink: 'tel:+1-231-928-8820',
        fax: '231.928.8825',
    }
    conf.$emails = {
        support: {
            display: 'support@brooksidelaser.com',
            link: 'mailto:support@brooksidelaser.com',
        },
        info: {
            display: "contact@brooksidelaser.com",
            link: 'mailto:contact@brooksidelaser.com',
        },
        privacy: {
            display: 'privacy@brooksidelaser.com',
            link: 'mailto:privacy@brooksidelaser.com',
        },
        website: {
            display: 'website@brooksidelaser.com',
            link: 'mailto:website@brooksidelaser.com',
        },
    }

//pages
    conf.$pages = {
        home: {
            enabled: true,
            name: 'Home',
            icon: 'icon-home',
        },
        about: {
            enabled: true,
            name: 'About Us',
            icon: 'icon-about',
        },
        design: {
            enabled: true,
            name: 'Design',
            icon: 'icon-compass',
        },
        fundraising: {
            enabled: false,
            name: 'Fundraising',
            icon: 'icon-fundraise',
        },
        engraving: {
            enabled: false,
            name: 'Engraving',
            icon: 'icon-laser',
        },
        marking: {
            enabled: true,
            name: 'Marking',
            icon: 'icon-marker',
        },
        printing: {
            enabled: true,
            name: 'Printing',
            icon: 'icon-printer',
        },
        partner: {
            enabled: true,
            name: 'Partner',
            icon: 'icon-handshake',
        },
        dtf: {
            enabled: false,
            name: 'DTF',
            icon: 'icon-sticker',
        },
        sublimation: {
            enabled: false,
            name: 'Sublimation',
            icon: 'icon-sublimation',
        },
        store: {
            enabled: false,
            name: 'Online Store',
            icon: 'icon-cash',
        },
    }

    conf.$links = {
        fb: {
            id:1,
            enabled: false,
            name: "Facebook",
            url: "https://facebook.com/brookside",
            iconBase: true,
            icon: 'icon-facebook',
        },
        ig: {
            id:2,
            enabled: false,
            name: "instagram",
            url: "https://instagram.com/brookside",
            iconBase: true,
            icon: 'icon-instagram',
        },
        store: {
            id:3,
            enabled: false,
            name: "Online Store",
            url: "https://shop.brooksidecustom.com/",
            iconBase: false,
            icon: 'icon-cash',
        },
        yt: {
            id:4,
            enabled: true,
            name: "MILaserGuy",
            url: "https://youtube.com/@milaserguy",
            iconBase: true,
            icon: 'icon-youtube',
        },
    }

    conf.$legalpages = {
        contact: {
            id: 1,
            enabled: true,
            name: 'Contact',
            small: false,
            icon: 'icon-at',
        },
        support: {
            id: 2,
            enabled: true,
            name: 'Support',
            small: true,
            icon: '',
        },
        privacy: {
            id: 3,
            enabled: true,
            name: 'Privacy',
            small: true,
            icon: '',
        },
        tos: {
            id: 4,
            enabled: true,
            name: 'ToS',
            small: true,
            icon: '',
        },
    }

// toast defaults
// const toastOptions = {
//     position: 'bottom-right',
//     timeout: 2000,
//     closeOnClick: true,
//     pauseOnHover: true,
//     draggable: false,
//     hideProgressBar: true,
//     closeButton: 'button',
//     icon: true,
//     rtl: false,
// }
// app.use(Toast,toastOptions)

app.use(router).mount('#app')
